<template>
  <div>
    <v-alert
      v-if="!showTable"
      border="top"
      colored-border
      :color="`section${sectionNumber}`"
      elevation="1"
      transition="scale-transition"
      tile
    >
      <v-row>
        <v-col class="grow">
          <div class="body-2">
            <slot name="card-info"></slot>
          </div>
        </v-col>
        <v-col class="shrink">
          <v-btn color="section0" dark @click="showTable = true" tile small>
            <div class="body-2">{{ $t("interface.learnMore") }}</div></v-btn
          >
        </v-col>
      </v-row>
    </v-alert>
    <v-card v-if="showTable">
      <v-card-title>
        <slot name="table-title"></slot>
      </v-card-title>
      <v-card-text class="px-0">
        <v-data-table
          height="300px"
          :mobile-breakpoint="800"
          :headers="tableHeaders"
          :items="tableData"
          :items-per-page="100"
          class="elevation-1"
          :fixed-header="true"
          hide-default-footer
          :sort-by="sortedColumn"
          sort-desc
        ></v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          small
          tile
          dark
          color="section0"
          @click="showTable = false"
          justify-top
        >
          <div class="body-2">{{ $t("interface.hideTable") }}</div></v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    tableHeaders: { type: Array, required: true },
    tableData: { type: Array, required: true },
    sortedColumn: { type: String, required: true },
    sectionNumber: { type: Number, required: true }
  },
  data() {
    return {
      showTable: false
    };
  }
};
</script>


<style>
th {
  font-size: 24px;
}
</style>